const { mergeInWallet } = require('./brokerCustomWalletParseHelper');

// set or replace the portfolio id that should be on edition mode
const setOnEditionMode = (state, idPortfolioAccount) => {
    const portfolioToUnset = state.get('idPortfolioOnEdition');
    const newState = mergeInWallet(state, portfolioToUnset, (wallet) => {
        return wallet.merge({
            editionMode: false
        });
    });

    return mergeInWallet(newState, idPortfolioAccount, (wallet) => {
        return wallet.merge({
            editionMode: true
        });
    });
};

const rejectConflictEditMode = (state) => {
    return state.set('editModeConflict', false);//para mostrar modal de conflicto
}

const setOnViewMode = (state, payload) => {
    return mergeInWallet(state, payload.idPortfolioAccount, (wallet) => {
        return wallet.merge({
            editionMode: false
        });
    });
}

module.exports = {
    setOnEditionMode,
    rejectConflictEditMode,
    setOnViewMode
};
